import React, { useEffect } from "react";
import { fieldsTimeOutValue } from "components/Field/index";
import infoIcon from "icons/info-new-rows.svg";
import PropTypes from "prop-types";
import { uniqueId } from "utils";

const PasswordField = ({
  password,
  setPassword,
  passwordError,
  setPasswordError,
  labelText,
  placeHolder
}) => {
  const id = uniqueId();

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (password?.length < 8 && password?.length > 0) {
        setPasswordError("The minimum length for this field is 8");
      } else if (password && !/\d+/.test(password)) {
        setPasswordError("Password must contain at least one digit");
      } else {
        setPasswordError("");
      }
    }, fieldsTimeOutValue);
    return () => clearTimeout(timeOutId);
  }, [password]);

  return (
    <label
      htmlFor={`${id}_form_field-password`}
      className="form__field__password"
    >
      <span data-title="The password must be at least 8 characters long and contain at least 1 letter and 1 number.">
        <b>
          {labelText || "Password"} <img src={infoIcon} alt="password info" />
        </b>
      </span>
      <input
        type="password"
        id={`${id}_form_field-password`}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className={passwordError && "input__error"}
        placeholder={placeHolder}
      />
      <span className={`input__error__message ${passwordError && "show"}`}>
        {passwordError}
      </span>
    </label>
  );
};

export default PasswordField;

PasswordField.propTypes = {
  password: PropTypes.string.isRequired,
  setPassword: PropTypes.func.isRequired,
  passwordError: PropTypes.string.isRequired,
  setPasswordError: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  placeHolder: PropTypes.string,
};
